<mat-expansion-panel (opened)="panelOpen = true" (closed)="panelOpen = false" hideToggle>
    <mat-expansion-panel-header class="py-5 px-4">
        <mat-panel-title class="d-flex">
            <div class="container d-flex flex-column">
                <h2 class="header-title" [class.complete]="this.propertyId" [class.error]="!this.propertyId && panelOpen">Property</h2>
            </div>
            <div>
                <mat-icon *ngIf="!panelOpen && !this.propertyId" class="header-toggle">
                    expand_more
                </mat-icon>
                <mat-icon *ngIf="panelOpen && this.propertyId" class="header-toggle complete">
                    checked
                </mat-icon>
                <mat-icon *ngIf="!panelOpen && this.propertyId" class="header-toggle complete">
                    checked
                </mat-icon>
                <mat-icon *ngIf="panelOpen && !this.propertyId" class="header-toggle error">
                    close
                </mat-icon>
            </div>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-card style="background-color:transparent; box-shadow:none;">
        @if(this.propertyId) {
            <app-properties-detail 
                [propertyId]="propertyId"
                [disableActions]="true"
            >
            </app-properties-detail>
        } @else {
            <p class="mx-auto">No property selected.</p>
        }
    </mat-card>
    <div class="row mt-2">
        <button mat-raised-button
            class="action-button select-property-button align-items-center w-fit"
            (click)="onShowPropertySearchClick()"
        >
            <mat-icon>add</mat-icon>
            Select Property
        </button>
    </div>
</mat-expansion-panel>